/** Read-only until organization email preferences have a supported delivery contract. */
import "./notificationsAthletic.css";

const NotificationsTab = () => (
  <section className="sh-notifications" data-testid="notifications-tab" aria-labelledby="notifications-unavailable-heading">
    <h2 id="notifications-unavailable-heading">Organization email preferences aren’t available yet</h2>
    <p>This page does not control existing registration confirmation or payment emails.</p>
  </section>
);

export default NotificationsTab;
